module.exports = __webpack_public_path__ + "static/media/teacher.e53de411.svg";